// config/brands.js
import iremedyLogo from '../assets/brands/iremedy-logo.png';
import oxfordLogo from '../assets/brands/patriot-logo.png';
import oxfordHero from '../assets/brands/oxford-hero.webp';
import oxfordHeaderLogo from '../assets/brands/oxford-header-logo.png';
import iremedyHeaderLogo from '../assets/brands/iremedy-header-logo.png';
import meridianHeaderLogo from '../assets/brands/meridian-header-logo.svg';


export const BRANDS = {
  iremedy: {
    id: 'iremedy',
    name: 'Oxford',
    logo: oxfordLogo,
    headerLogo: oxfordHeaderLogo,
    heroImage: oxfordHero,
    tagline: 'Zero-Middleman Prescriptions',
    isB2B: false,
    ctaText: 'Start Saving',
    hero: {
      headline: 'Your Prescriptions. Zero Middlemen.',
      subhead: 'FDA-licensed pharmacy delivering generic medications directly from manufacturers. No PBMs. No markup. Just medicine.',
      cta: 'Start Saving Today'
    },
    c: {
      navy: '#1A365D',
      navyMid: '#2C5282',
      accent: '#3B82F6',
      accentDark: '#2563EB',
      gold: '#F5C675',
      blue: '#3B82F6',
      blueLight: '#EFF6FF',
      headerBg: '#1A365D',
      heroBg: 'linear-gradient(135deg, #1A365D 0%, #3B82F6 100%)',
      trustBar: '#2C5282',
      stripeEven: '#F0F9FF',
      stripeOdd: '#DBEAFE'
    }
  },
  meridian: {
    id: 'meridian',
    name: 'Meridian Health System',
    headerLogo: meridianHeaderLogo,
    tagline: 'Direct Procurement Infrastructure',
    isB2B: true,
    ctaText: 'Request Demo',
    hero: {
      headline: 'Your Supply Chain is Costing You Millions',
      subhead: 'Hospital procurement teams lose 15-30% to GPO fees and distributor markup. Licensed direct distribution eliminates intermediaries and delivers FDA-compliant products at true wholesale cost.',
      cta: 'Request Demo'
    },
    c: {
      navy: '#0F172A',
      navyMid: '#1E293B',
      accent: '#14B8A6',
      accentDark: '#0D9488',
      gold: '#F59E0B',
      blue: '#14B8A6',
      blueLight: '#F0FDFA',
      headerBg: '#0F172A',
      heroBg: 'linear-gradient(135deg, #0F172A 0%, #14B8A6 100%)',
      trustBar: '#134E4A',
      stripeEven: '#F0FDFA',
      stripeOdd: '#CCFBF1'
    }
  },
  oxford: {
    id: 'oxford',
    name: 'iRemedy',
    logo: iremedyLogo,
    headerLogo: iremedyHeaderLogo,
    tagline: 'American-Made Medications',
    isB2B: false,
    ctaText: 'Buy American',
    hero: {
      headline: 'American Medications. American Manufacturing.',
      subhead: '100% USA-manufactured generic drugs delivered direct from FDA-licensed facilities. No foreign APIs. No middlemen. Just American medicine.',
      cta: 'Buy American'
    },
    c: {
      navy: '#1A365D',
      navyMid: '#2C5282',
      accent: '#3B82F6',
      accentDark: '#2563EB',
      gold: '#F5C675',
      blue: '#3B82F6',
      blueLight: '#EFF6FF',
      headerBg: '#1A365D',
      heroBg: 'linear-gradient(135deg, #1A365D 0%, #3B82F6 100%)',
      trustBar: '#2C5282',
      stripeEven: '#F0F9FF',
      stripeOdd: '#DBEAFE'
    }
  }
};
